import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HomeGlyph = /*#__PURE__*/createElement("g", {
  id: "home"
}, /*#__PURE__*/createElement("path", {
  d: "M41.9,14.3c0.1-0.1,0.1-0.1,0.2,0c8.1,8.9,16.2,17.8,24.3,26.7c0.5,0.6,1.5,0.6,2.1,0.1c0.6-0.6,0.6-1.5,0.1-2.1 c-8.3-9.1-16.6-18.1-24.8-27.2c-1-1.1-2.6-1.1-3.6,0C31.9,20.8,23.6,29.9,15.4,39c-0.5,0.6-0.5,1.5,0.1,2.1 c0.6,0.6,1.5,0.5,2.1-0.1C25.7,32.1,33.8,23.2,41.9,14.3"
}), /*#__PURE__*/createElement("path", {
  d: "M60.9,65.9c0,0.1,0,0.1-0.1,0.1c-12.5,0-25,0-37.6,0c-0.1,0-0.1,0-0.1-0.1c0-4.6,0-9.1,0-13.7c0-2.3,0-4.6,0-6.9 c0-0.9,0.2-1.7,0-2.7c-0.1-0.5-0.4-0.8-0.9-1c-0.9-0.3-1.9,0.3-2,1.3c-0.1,2.3,0,4.6,0,6.9c0,2.3,0,4.6,0,6.9c0,2.3,0,4.6,0,6.9 c0,1,0,2,0,3c0,1.4,1.1,2.5,2.4,2.5c13,0,26,0,38.9,0c1.4,0,2.4-1.1,2.4-2.5c0-1,0-2,0-3c0-2.3,0-4.6,0-6.9c0-2.3,0-4.6,0-6.9 c0-2.3,0.1-4.6,0-6.9c-0.1-1-1-1.7-2-1.3c-0.5,0.2-0.8,0.5-0.9,1c-0.2,0.9,0,1.8,0,2.6c0,2.3,0,4.6,0,6.9 C60.9,56.8,60.9,61.3,60.9,65.9"
}));
const Home = createSvg({
  name: 'home',
  path: HomeGlyph
});

export default Home;
export { HomeGlyph };
